export default __webpack_public_path__ + "530e07f330fdd307e9ceafb9bcf0cc76.svg";